import { Button, ICON_COLOR, IconButton } from '@zep-us/zus';
import { FolderIcon, PenPaperIcon, QrcodeIcon, SquareStackIcon } from '@zep-us/zus-icons';
import { useTranslation } from 'next-i18next';
import { PlayFillIcon } from '@/icons/components/PlayFill';
import { FOLDER_COPY } from '@/shared/features/quiz-folder';
export interface MobileOwnerCTAButtonsProps {
  onEnter: () => void;
  onShare: () => void;
  onDuplicate: () => void;
  onEdit: () => void;
  onMoveToFolder?: () => void;
}
export const MobileOwnerCTAButtons = ({
  onEnter,
  onShare,
  onDuplicate,
  onEdit,
  onMoveToFolder
}: MobileOwnerCTAButtonsProps) => {
  const {
    t
  } = useTranslation(['common']);
  return <div className="flex w-full flex-row gap-xs" data-sentry-component="MobileOwnerCTAButtons" data-sentry-source-file="MobileOwnerCTAButtons.tsx">
      <Button size="md" variant="contained" intent="gradient" onClick={onEnter} leftSlot={<PlayFillIcon size="sm" fill={ICON_COLOR.inverse} />} className="flex-1" data-sentry-element="Button" data-sentry-source-file="MobileOwnerCTAButtons.tsx">
        {t('global.enter.button')}
      </Button>

      <IconButton size="md" variant="contained" intent="alternative" onClick={onShare} data-sentry-element="IconButton" data-sentry-source-file="MobileOwnerCTAButtons.tsx">
        <QrcodeIcon size="sm" fill={ICON_COLOR.strong} data-sentry-element="QrcodeIcon" data-sentry-source-file="MobileOwnerCTAButtons.tsx" />
      </IconButton>

      {/*
        내 퀴즈는 복사가 아니라 이동이다 — 데스크톱 소유자 CTA 의 `폴더 이동` 과 같은 자리.
        아이콘만 있는 버튼이라 라벨 대신 `aria-label` 로 이름을 준다(시안 34388:41137).
       */}
      {onMoveToFolder && <IconButton size="md" variant="outlined" intent="neutral" aria-label={FOLDER_COPY.moveToFolder} onClick={onMoveToFolder}>
          <FolderIcon size="sm" fill={ICON_COLOR.neutral} />
        </IconButton>}

      <IconButton size="md" variant="outlined" intent="neutral" onClick={onDuplicate} data-sentry-element="IconButton" data-sentry-source-file="MobileOwnerCTAButtons.tsx">
        <SquareStackIcon size="sm" fill={ICON_COLOR.neutral} data-sentry-element="SquareStackIcon" data-sentry-source-file="MobileOwnerCTAButtons.tsx" />
      </IconButton>

      <IconButton size="md" variant="outlined" intent="neutral" onClick={onEdit} data-sentry-element="IconButton" data-sentry-source-file="MobileOwnerCTAButtons.tsx">
        <PenPaperIcon size="sm" fill={ICON_COLOR.neutral} data-sentry-element="PenPaperIcon" data-sentry-source-file="MobileOwnerCTAButtons.tsx" />
      </IconButton>
    </div>;
};